const NoMapUrlAlert = (neighborhoodName, link) => ({
  heading: "We’re sorry",
  message: `A map of home sites for ${neighborhoodName} is currently unavailable.`,
  link: link,
  linkHeading: neighborhoodName,
});
const LanscapeAlert = () => ({
  heading: "We’re sorry",
  message: "This screen is too small to display a map of home sites. Try rotating the screen or switching to a computer, laptop or other device with a larger screen.",
  link: "",
  linkHeading: "",
});

const NoPlatmapAlert = () => ({
  heading: "We’re sorry",
  message: `This map of home sites could not be loaded.`,
  link: "http://dreeshomes.com/",
  linkHeading: "Drees Homes community",
});

const InvalidURLAlert = () => ({
  heading: "We’re sorry",
  message: `This map of home sites could not be loaded.`,
  link: "http://dreeshomes.com/",
  linkHeading: "Drees Homes communities",
});

const NotFoundAlert = () => ({
  heading: "404",
  message: `not found`,
  link: "",
  linkHeading: "",
})

export { NoMapUrlAlert, LanscapeAlert, NoPlatmapAlert, InvalidURLAlert, NotFoundAlert };
